// Remove Shopify's customer_posted success param from the URL immediately
// so a page refresh won't re-render the success message.
(function () {
  const url = new URL(window.location.href);
  if (url.searchParams.has('customer_posted')) {
    url.searchParams.delete('customer_posted');
    history.replaceState(null, '', url.toString());
  }
})();

class ConsentCheckboxBlock extends HTMLElement {
  connectedCallback() {
    this._checkbox = this.querySelector('.consent-checkbox__input');
    this._errorEl = this.querySelector('.consent-checkbox__error');

    if (!this._checkbox) return;

    this._checkbox.addEventListener('change', () => {
      if (this._checkbox.checked && this._errorEl) {
        this._errorEl.hidden = true;
      }
    });

    this._handleSubmit = (e) => {
      if (!this._checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this._errorEl) {
          this._errorEl.hidden = false;
          this._errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        this._checkbox.focus();
      }
    };

    this._form = this._findForm();

    if (this._form) {
      this._form.addEventListener('submit', this._handleSubmit, true);
    } else {
      setTimeout(() => {
        this._form = this._findForm();
        if (this._form) {
          this._form.addEventListener('submit', this._handleSubmit, true);
        }
      }, 800);
    }
  }

  _findForm() {
    let el = this.parentElement;
    for (let i = 0; i < 12; i++) {
      if (!el) break;
      const form = el.querySelector('.email-signup__form');
      if (form) return form;
      el = el.parentElement;
    }
    return document.querySelector('.email-signup__form');
  }

  disconnectedCallback() {
    if (this._form && this._handleSubmit) {
      this._form.removeEventListener('submit', this._handleSubmit, true);
    }
  }
}

customElements.define('consent-checkbox', ConsentCheckboxBlock);
